/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * A lang provider which get us the required locale from query string
 *
 * @file addLocale.js
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.0
 */

import { addLocaleData } from 'react-intl';

import { DEFAULT_LOCALE } from '../common/constants';

export const AddLocaleData = (locale) => { // eslint-disable-line
  const lang = locale || DEFAULT_LOCALE;
  // load locale data
  const parentLocale = lang.split('-')[0];

  try {
    addLocaleData(require(`react-intl/locale-data/${parentLocale}`));// eslint-disable-line
  } catch (e) {
    // TODO: need to add logger
    console.log(e);
  }
};
